import {CompanyAnnexType} from "@/types/enums/enums.ts";

export class CompanyAnnex {
    public id: number | null;
    public company_id: number;
    public company_business_line_id: number;
    public contract_id: number;
    public date_annex_signed: Date | null;
    public annex_type: CompanyAnnexType;
    public revoked: boolean;
    public revoked_by_user_id: number | null;
    public renewal: number | null;
    public annex_period: number | null;
    public file_name: string | null;
    public file_content_base64: string | null;

    constructor(data: CompanyAnnexData | void) {
        if (data === undefined) {
            this.id = null;
            this.company_id = 0;
            this.company_business_line_id = 0;
            this.contract_id = 0;
            this.date_annex_signed = null;
            this.annex_type = CompanyAnnexType.TARIFF;
            this.revoked = false;
            this.revoked_by_user_id = 0;
            this.renewal = null;
            this.annex_period = 0;
            this.file_name = null
            this.file_content_base64 = null
        } else {
            this.id = data.id;
            this.company_id = data.company_id;
            this.company_business_line_id = data.company_business_line_id;
            this.contract_id = data.contract_id;
            this.date_annex_signed = null;
            if (data.date_annex_signed !== null && data.date_annex_signed !== undefined) {
                this.date_annex_signed = new Date(data.date_annex_signed);
            }
            this.annex_type = data.annex_type;
            this.revoked = data.revoked;
            this.revoked_by_user_id = data.revoked_by_user_id;
            this.renewal = data.renewal;
            this.annex_period = data.annex_period;
            this.file_name = data.file_name;
            this.file_content_base64 = data.file_content_base64;
        }
    }

    serializeData(without_relations: boolean | Array<string> = false, with_relations: boolean | Array<string> = false, ids_only: boolean = false): CompanyAnnexData {
        const serialized_data = {
            id: this.id,
            company_id: this.company_id,
            company_business_line_id: this.company_business_line_id,
            contract_id: this.contract_id,
            date_annex_signed: this.date_annex_signed,
            annex_type: this.annex_type,
            revoked: this.revoked,
            revoked_by_user_id: this.revoked_by_user_id,
            renewal: this.renewal,
            annex_period: this.annex_period,
            file_name: this.file_name,
            file_content_base64: this.file_content_base64,

        }
        return serialized_data;
    }

}

export type CompanyAnnexData = {
    id: number | null;
    company_id: number;
    company_business_line_id: number;
    contract_id: number;
    date_annex_signed: Date | null;
    annex_type: CompanyAnnexType;
    revoked: boolean;
    revoked_by_user_id: number | null;
    renewal: number | null;
    annex_period: number | null;
    file_name: string | null;
    file_content_base64: string | null;
}
